export default __webpack_public_path__ + "media/images/logo-default-49a229b0421d8d053197fb9b349417a1.svg";